module.exports = __webpack_public_path__ + "static/media/tablet_background.5e9836a2.png";